<template>
  <div class="msg">
    <div class="msg-container">
      <div class="msg-container_user">
        <div class="msg-search">
          <img src="@/assets/images/icon_feather-search.svg" alt="i" />
          <input type="text" placeholder="検索する" />
        </div>
        <div class="msg-users_list">
          <div v-for="(user, i) of users" :key="i">
            <div
              class="msg_user"
              :class="user.isSelected ? 'user-selected' : ''"
            >
              <div class="msg_user-img">
                <img src="@/assets/images/messi.jpg" alt="ava" />
              </div>
              <div class="msg_user-info">
                <div class="msg_user-name">{{ user.name }}</div>
                <div class="msg_user-description jtf_between">
                  <div class="msg_user-time">{{ user.time }}</div>
                  <CusStatus class="msg_user-status" :item="user.status">
                    {{ user.status }}
                  </CusStatus>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="msg-container_content">
        <div class="msg_user-shown">
          <div class="msg_shown-info">
            <img src="@/assets/images/messi.jpg" alt="ava" />
            <div class="msg_user-name">{{ users[0].name }}</div>
          </div>
          <div v-if="isChatted" class="msg_shown-setting">
            <slot name="bell-icon"></slot>
          </div>
          <div v-else class="msg_shown-setting">
            <div>
              <img
                src="@/assets/images/bell.svg"
                alt="bell"
                height="18"
                width="18"
              />
            </div>
            <div class="msg_set-rate">評価設定</div>
            <div class="msg_set-no">未設定</div>
          </div>
        </div>
        <div class="msg_main">
          <div class="msg_main-wrap">
            <slot name="msg-main"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import CusStatus from '@/components/status/CustomStatus.vue';

const props = defineProps({
  isChatted: {
    type: Boolean,
    default: false,
  },
});

const users = reactive([]);
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大和田新築アパート体操の魅力を多くの人たちに知ってもらおうと現役の 体操の魅力を多くの人たちに知って体操の魅力を多くの人たちに知ってもらおうと現役の 体操の魅力を多くの人たちに知って',
  status: '承諾待ち',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: true,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大和田新築アパート体操の魅力を多くの人たちに知ってもらおうと現役の 体操の魅力を多くの人たちに知って体操の魅力を多くの人たちに知ってもらおうと現役の 体操の魅力を多くの人たちに知って',
  status: '承諾待ち',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: true,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '承諾済',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '落札取消',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '承諾待ち',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '落札取消',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '承諾待ち',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '承諾済',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
users.push({
  name: '◆想定9.01%◆駅徒歩2分！！八千代市大八市大八',
  status: '承諾済',
  time: '2021/06/02 13:00:24',
  img: '@/assets/images/messi.jpg',
  isSelected: false,
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/common.scss";
.l-header {
  z-index: 1;
}
.msg {
  max-width: 1400px;
  margin: 0 auto;
  &-container {
    height:732px;
    display: flex;
    &_user {
      flex-shrink: 0;
      width: 407px;
      height: 732px;
      overflow: auto;
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 7px 0px 40px #88888829;
      &::-webkit-scrollbar-thumb {
        background: #6262622b;
      }
      &::-webkit-scrollbar {
        width: 8px;
        height: 301px;
      }
      .msg-search {
        position: relative;
        margin: 10px 14px;
        input {
          padding: 13px;
          padding-left: 41px;
          width: 100%;
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 11px 13px #91919129;
          border: 1px solid #04a4de;
          border-radius: 5px;
          outline: none;
          &::placeholder {
            color: #9f9f9f;
            opacity: 65%;
          }
        }
        img {
          height: 14px;
          width: 14px;
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(100%, 123%);
        }
      }
      .msg-users_list {
        padding: 0 12px;
        .msg_user {
          padding: 20px 15px 14px;
          display: flex;
          &-img {
            padding-right: 12px;
            img {
              width: 44px;
              height: 44px;
              border-radius: 50%;
              object-fit: cover;
            }
          }
          &-info {
            .msg_user-name {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 297px;
              font-weight: 600;
            }
            .msg_user-description {
              margin-top: 5px;
              .msg_user-time {
                color: #9f9f9f;
                font-size: 12px;
                display: flex;
                align-items: center;
              }
              .msg_user-status {
                border-radius: 16px;
                border: 1px solid transparent;
                width: 70px;
                height: 26px;
                font-weight: 600;
                text-align: center;
              }
              .orrange {
                background-color: #ffeee8;
                color: #fd7444;
              }
              .green {
                background-color: #cfffdc;
                color: #27b737;
              }
              .gray {
                background-color: #f5f5f5;
                color: #9f9f9f;
              }
            }
          }
        }
        .user-selected {
          background: #f5fcff 0% 0% no-repeat padding-box;
          border: 1px solid #04a4de;
          border-radius: 5px;
        }
      }
    }
    &_content {
      background: #ffffff;
      padding: 10px 27px;

      .msg_user-shown {
        border-bottom: 1px solid #f2f2f2;
        margin: 0 -26px;
        padding: 0px 30px 12px 30px;
        display: flex;
        .msg_shown-info {
          display: flex;
          flex: 0 1 82%;
          margin-right: 23px;
          img {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            margin-right: 10px;
            object-fit: cover;
          }
          .msg_user-name {
            font-weight: 600;
            height: 45px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .msg_shown-setting {
          display: flex;
          align-items: center;
          div {
            margin-right: 14px;
            cursor: pointer;
          }
          div:last-child {
            margin-right: 0;
            color: #747474;
            font-weight: 600;
          }
          .msg_set-rate {
            color: #9f9f9f;
          }
        }
      }
      .msg_main {
        display: flex;
        justify-content: center;
        margin-top: 170px;
      }
    }
  }
}
</style>
